import React from 'react';
import { graphql } from 'gatsby'
import Options from './Options';
import Game from './Game';
import Finish from './Finish';
import useOptions from '../utils/useOptions';
import { normalizeLanguage } from '../utils/translations';
import Helmet from "react-helmet"
import 'minireset.css'
import '../fonts/fonts.css';
import '../styles/main.css';
import '../styles/themes.css';
import { Global, css } from '@emotion/core'

function App({ data }) {

  const [options, game, set] = useOptions();
  const language = normalizeLanguage(data.game.frontmatter.language);
  const component = {
    playing: (
      <Game {...set} {...options} {...game} data={data} language={language} />
      ),
    finished: (
      <Finish {...set} {...options} {...game} data={data} language={language} />
    ),
    options: (
      <Options {...options} {...set} data={data} language={language} />
    )
  }

  const bgColor = data.game.frontmatter.backgroundColor || '#000'
  const textColor = data.game.frontmatter.textColor || '#fff'
  const bgImage = ( ( ( (data.game.frontmatter.screenback)==null) || ( (typeof data.game.frontmatter.screenback)=='undefined'))? 'none':('url('+data.game.frontmatter.screenback.publicURL+')')  )

  let number_columns = 6;
  console.log("data.game: ",data);

  let usedNumberOfCards = data.game.frontmatter.cards.length;
  if ( (parseInt(data.game.frontmatter.cardsHorizontal)>0) && (parseInt(data.game.frontmatter.cardsVertical)>0) ) {
    usedNumberOfCards = parseInt(data.game.frontmatter.cardsHorizontal) * parseInt(data.game.frontmatter.cardsVertical) /2;
  }
  if (usedNumberOfCards===8) { number_columns = 4; }
  if (usedNumberOfCards===6) { number_columns = 4; }
  const numberRows = Math.ceil((usedNumberOfCards * 2) / number_columns);
  const deckAspectRatio = number_columns / numberRows;

  return (
    <>
    <Helmet 
    title="Memory"
    htmlAttributes={{ lang: language }}
    meta={[
      {
      name:`viewport`,
      content:`width=device-width, initial-scale=1, viewport-fit=cover`
      },
      {
      name:`apple-mobile-web-app-capable`,
      content:`yes`
      }
    ]}
    />
    <Global
      styles={css`
        body, html {
          background: ${bgColor};
          color: ${textColor};
        }
        nav button, nav .button {
          background-color: ${bgColor};
          color: ${textColor};
          border: 2px solid ${textColor};
        }
        .card{
          :focus {
            outline: 1px ${bgColor} dotted;
          }
        }
        .card.default .front{
          color: ${bgColor};
          
         }
         .card.default .back{
           background-color: ${textColor};
           border: 1px solid ${textColor};
         }
        
         .finish.default {
           background: ${bgColor};
         }
         .game {
          --deck-columns: ${number_columns};
          --deck-rows: ${numberRows};
          --deck-max-width: min(1120px, calc((100vh - 7rem) * ${deckAspectRatio}));
         }
         .deck {
          grid-template-columns: repeat(${number_columns}, minmax(0, 1fr)) !important;
         }
         @supports (height: 100dvh) {
          .game {
            --deck-max-width: min(1120px, calc((100dvh - 7rem) * ${deckAspectRatio}));
          }
         }
         .start {
          background-image: ${bgImage};
          background-size: cover;
         }

      `}
      />
    {/* <Theme> */}
    {component[game.status]}
    {/* </Theme> */}
    </>
  )
  ;
}

export default App;

export const query = graphql`
  query Game($id: String) {
    game: markdownRemark(id: { eq: $id }) {
      fields {
        slug
      }
      frontmatter {
        client
        language
        welcomeText
        backgroundColor
        textColor
        cardsHorizontal
        cardsVertical
        screenback {
          publicURL
        }
        cardback {              
          publicURL
        }
          cards {
            image {
              id
              publicURL
            }
          }
        }
    }
  }
`
